import React from "react";
import "./Button.css";
import { Link } from "react-router-dom";

const STYLES = ["btn__primary", "btn__outline", "btn__test", "btn__rounded"];

const SIZES = ["btn__medium", "btn__large"];

export const Button = ({
  children,
  type,
  onClick,
  buttonStyle,
  buttonSize,
}) => {
  const checkButtonStyle = STYLES.includes(buttonStyle)
    ? buttonStyle
    : STYLES[0];

  const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];

  return (
    <span className="btn-mobile">
      <button
        className={`btn ${checkButtonStyle} ${checkButtonSize}`}
        onClick={onClick}
        type={type}
      >
        {children}
      </button>
    </span>
  );
};
